export enum CALENDAR_RESOURCE_TYPE {
  technician = 'technician',
  technicianTeam = 'team',
  serviceProvider = 'sp'
}